import { AppNavSection, CollapseAppNavButton } from "@qw/ui";
import { AppNav } from "@/components/app-nav/app-nav";

import { BankanLinks } from "./bankan-links";

export const BankanNav = () => (
  <AppNav className="w-64!">
    <BankanLinks />
    <AppNavSection>
      <CollapseAppNavButton />
    </AppNavSection>
  </AppNav>
);
